'use client';

import {
  Box,
  Heading,
  Image,
  Flex,
  Text,
  Stack,
} from '@chakra-ui/react';
import { HoveringBox } from '~/components/ui/motion/Box';

export default function AgencyNotFound() {
  return (
    <Flex direction="column" justifyContent="center">
      <HoveringBox>
        <Image
          w="xs"
          mx="auto"
          mb="6"
          src={'/agencies/default/illustrations/maintenance.svg'}
          alt="Underhåll pågår"
        />
      </HoveringBox>

      <Box px="2">
        <Stack textAlign="center" spacing="6" maxW="600" mx="auto">
          <Heading textAlign="center" size={{ mobile: 'md', tablet: 'lg' }}>
            Renoveringsarbete pågår
          </Heading>
          <Text fontSize={{ mobile: 'md', tablet: 'lg' }}>
            Vår webbplats för mäklartjänster uppgraderas för att ge dig ännu
            bättre användarupplevelse. Vi är snart tillbaka med en ny och
            förbättrad plattform. Tack för tålamodet!
          </Text>
        </Stack>
      </Box>
    </Flex>
  );
};
